module.exports = __webpack_public_path__ + "img/Logo-long-w.e3569c22.svg";